(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initMobileFooter);
  window.addEventListener('resize', function(){
    setTimeout(() => {
      initMobileFooter(); 
    }, 1);
  });
  async function initMobileFooter()
  {
    const isMobile = window.innerWidth < 768; 

    // Only run on small screens
    var toggles = document.querySelectorAll('.footer-toggle');

    toggles.forEach(function (toggle) {
      var targetMenu = document.getElementById('footer-menu-' + toggle.dataset.index);
        
      // Initially hide all
      if (targetMenu && isMobile) {
        targetMenu.style.display = 'none';
      }
      else if (!isMobile)
      {
        targetMenu.style.display = 'block';
      }

      if (isMobile)
      {
        toggle.addEventListener('click', function () {
          if (!targetMenu) return;

          var isOpen = targetMenu.style.display === 'block';
          targetMenu.style.display = isOpen ? 'none' : 'block';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // unstick the header for product page
  document.addEventListener('DOMContentLoaded', function () {
    Site.unstickOrRestickHeader();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-youll-love-this-lube"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lube-carousel')) {
    customElements.define('lube-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.count = Number(this.dataset.slideCount || 0);
        this.delay = Number(this.dataset.autoplayDelay || 5500);
        this.viewport = this.querySelector('.lube-carousel__viewport');
        this.abortController = new AbortController();
        this.startX = 0;
        this.deltaX = 0;
        this.dragging = false;
        if (this.count > 1) this.initCarousel();
        this.initReveal();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abortController?.abort();
        this.observer?.disconnect();
      }
      initCarousel() {
        const signal = this.abortController.signal;
        this.querySelector('[data-previous]').addEventListener('click', () => this.goTo(this.index - 1, true), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.goTo(this.index + 1, true), { signal });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot), true), { signal }));
        this.viewport.addEventListener('pointerdown', (event) => this.pointerDown(event), { signal });
        this.viewport.addEventListener('pointermove', (event) => this.pointerMove(event), { signal });
        this.viewport.addEventListener('pointerup', () => this.pointerUp(), { signal });
        this.viewport.addEventListener('pointercancel', () => this.pointerUp(), { signal });
        this.addEventListener('mouseenter', () => this.stop(), { signal });
        this.addEventListener('mouseleave', () => this.start(), { signal });
        this.addEventListener('focusin', () => this.stop(), { signal });
        this.addEventListener('focusout', () => this.start(), { signal });
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start(), { signal });
        this.start();
      }
      pointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.dragging = true;
        this.startX = event.clientX;
        this.deltaX = 0;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture(event.pointerId);
        this.stop();
      }
      pointerMove(event) {
        if (!this.dragging) return;
        this.deltaX = event.clientX - this.startX;
      }
      pointerUp() {
        if (!this.dragging) return;
        this.dragging = false;
        this.viewport.classList.remove('is-dragging');
        if (Math.abs(this.deltaX) > 45) this.goTo(this.index + (this.deltaX < 0 ? 1 : -1));
        this.start();
      }
      goTo(nextIndex, restart = false) {
        const next = (nextIndex + this.count) % this.count;
        if (next === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.dots[this.index].classList.remove('is-active');
        this.dots[this.index].setAttribute('aria-current', 'false');
        this.index = next;
        this.slides[this.index].classList.add('is-active');
        this.slides[this.index].removeAttribute('aria-hidden');
        this.dots[this.index].classList.add('is-active');
        this.dots[this.index].setAttribute('aria-current', 'true');
        if (restart) { this.stop(); this.start(); }
      }
      start() {
        if (this.count < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden) return;
        this.stop();
        this.timer = setInterval(() => this.goTo(this.index + 1), this.delay);
      }
      stop() { clearInterval(this.timer); }
      initReveal() {
        const cards = this.closest('.why-love-lube').querySelectorAll('[data-reveal]');
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: .15 });
        cards.forEach((card, index) => {
          card.style.transitionDelay = `${Math.min(index * 70, 280)}ms`;
          this.observer.observe(card);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
